import React, { useCallback, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { Visibility } from '@material-ui/icons';
import { format, parseISO, subDays } from 'date-fns';
import { isArray } from 'lodash';
import { toast } from 'react-toastify';

import { Modal, UnidataTable } from '~/components';
import { number, t } from '~/helpers';
import api from '~/services/api';
import {
  deleteData,
  recordFiltering,
} from '~/store/modules/transferenciaAreiaSilo/actions';

import Form from './form';
import View from './view';

function TransferenciaAreiaSilo() {
  const redux = useSelector((state) => state.transferenciaAreiaSilo);
  const modalRef = useRef(null);
  const [loadingView, setLoadingView] = useState(false);

  const buttons = useMemo(
    () => [
      {
        label: t('s.geral.botaofechar'),
        callback: () => modalRef.current.handleCloseModal(),
        color: 'secondary',
        autoFocus: true,
        variant: 'outlined',
      },
    ],
    []
  );

  const handleView = useCallback(async (value) => {
    try {
      setLoadingView(true);
      const { data } = await api.get(
        `transferenciaareiasilo/${value.idtransferenciaareiasilo}`
      );
      modalRef.current.handleOpenModal({ data: { ...value, ...data } });
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoadingView(false);
    }
  }, []);

  const actions = useMemo(
    () => [
      {
        title: t('s.geral.visualizar'),
        action: (value) => handleView(value),
        icon: <Visibility />,
      },
    ],
    [handleView]
  );

  const header = useMemo(
    () => [
      {
        id: 'codigonomeposto',
        label: t('s.configuracao.terminal.nomeposto'),
        filter: { type: 'text' },
      },
      {
        id: 'datahoratransferenciaareiasilo',
        label: t('s.operacao.transferenciaareiasilo.datahora'),
        formatted: (value) =>
          value ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : '',
        filter: {
          type: 'initialdatetime',
          defaultValue: format(subDays(new Date(), 7), 'dd/MM/yyyy 00:00:00'),
        },
      },
      {
        id: 'nomesilotransferenciaareiasilo',
        label: t('s.operacao.transferenciaareiasilo.silo'),
        filter: { type: 'text' },
      },
      {
        id: 'pesototalkgtransferenciaareiasilo',
        label: `${t('s.geral.pesototal')} Kg`,
        formatted: (value) => number(value || 0, '0'),
        filter: { type: 'number' },
      },
      {
        id: 'nomeusuariotransferenciaareiasilo',
        label: t('s.cadastro.usuario.usuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  return (
    <>
      <UnidataTable
        fixed
        redux={redux}
        header={header}
        read={recordFiltering}
        actions={actions}
        update={false}
        delete={false}
        remove={deleteData}
        form={Form}
        keys="idtransferenciaareiasilo"
        detach="codigonomeposto"
      />

      <Modal
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalRef}
        loading={loadingView}
        component={View}
        actions={buttons}
        title={t('s.menu.operacao.transferenciaareiasilo')}
        maxWidth="lg"
        noPadding
      />
    </>
  );
}

export default TransferenciaAreiaSilo;
